import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { RideFilter, DirectionFilter, RidesData } from '../types/ride';
import { fetchRides } from '../services/rideApi';

export const useRideStore = defineStore('ride', () => {
  const ridesData = ref<RidesData>({ from_bm: [], to_bm: [] });
  const selectedFilter = ref<RideFilter>('all');
  const selectedDirection = ref<DirectionFilter>('from_bm');
  const isLoading = ref(false);
  const error = ref<string | null>(null);
  const maintenanceMode = ref(false);

  const filteredRides = computed(() => {
    const rides = ridesData.value[selectedDirection.value];
    if (!rides.length) return [];
    if (selectedFilter.value === 'all') return rides;
    return rides.filter((ride) => ride.ride_type === selectedFilter.value);
  });

  const hasRides = computed(() => {
    return ridesData.value[selectedDirection.value].length > 0;
  });

  async function loadRides() {
    try {
      isLoading.value = true;
      error.value = null;
      maintenanceMode.value = false;
      
      const { data, error: apiError, maintenance } = await fetchRides();

      if (maintenance) {
        maintenanceMode.value = true;
        ridesData.value = { from_bm: [], to_bm: [] };
        return;
      }

      if (apiError) {
        error.value = apiError;
        ridesData.value = { from_bm: [], to_bm: [] };
        return;
      }

      if (data) {
        ridesData.value = data;
      }
    } catch (e) {
      error.value = 'Es ist ein unerwarteter Fehler aufgetreten';
      ridesData.value = { from_bm: [], to_bm: [] };
      console.error('Error in loadRides:', e);
    } finally {
      isLoading.value = false;
    }
  }

  function clearError() {
    error.value = null;
  }

  return {
    ridesData,
    selectedFilter,
    selectedDirection,
    isLoading,
    error,
    maintenanceMode,
    filteredRides,
    hasRides,
    loadRides,
    clearError,
  };
});